var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-form-prompt',{attrs:{"title":_vm.title,"active":_vm.isActive,"steps":_vm.steps,"accept-text":_vm.acceptText},on:{"update:active":function($event){_vm.isActive=$event},"completed":_vm.save},model:{value:(_vm.patientForm),callback:function ($$v) {_vm.patientForm=$$v},expression:"patientForm"}})
}
var staticRenderFns = []

export { render, staticRenderFns }